import type { IconNode } from '../types';

/**
 * @name playing-cards
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuODMyIDguNDQ1YTEgMSAwIDAwLTEuNTg5LS4wOThsLTIuMDc1IDMuMDk4YTEgMSAwIDAwMCAxLjExbDIgM2ExIDEgMCAwMDEuNjY0IDBsMi0zYTEgMSAwIDAwMC0xLjExeiIgLz4KICA8cGF0aCBkPSJtNy4xOCAyMC44MjctNS0xMWEyIDIgMCAwMS45OTMtMi42NDdMNyA1LjQ0IiAvPgogIDxyZWN0IHg9IjciIHk9IjIiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCIgcng9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/playing-cards
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const PlayingCards: IconNode = [
  [
    'path',
    {
      d: 'M14.832 8.445a1 1 0 00-1.589-.098l-2.075 3.098a1 1 0 000 1.11l2 3a1 1 0 001.664 0l2-3a1 1 0 000-1.11z',
    },
  ],
  ['path', { d: 'm7.18 20.827-5-11a2 2 0 01.993-2.647L7 5.44' }],
  ['rect', { x: '7', y: '2', width: '14', height: '20', rx: '2' }],
];

export default PlayingCards;
